
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-[1360px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Колонка 1 */}
          <div>
            <h3 className="font-mulish font-bold text-lg text-white mb-6">
              Путешествия
            </h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/search" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Поиск туров
                </Link>
              </li>
              <li>
                <Link 
                  to="/directions" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Направления
                </Link>
              </li>
              <li>
                <Link 
                  to="/types" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Виды отдыха
                </Link>
              </li>
              <li>
                <Link 
                  to="/corporate" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Компаниям
                </Link>
              </li>
              <li>
                <Link 
                  to="/individual" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Индивидуально
                </Link>
              </li>
            </ul>
          </div>

          {/* Колонка 2 */}
          <div>
            <h3 className="font-mulish font-bold text-lg text-white mb-6">
              Поддержка
            </h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/faq" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Вопрос-ответ
                </Link>
              </li>
              <li>
                <Link 
                  to="/reviews" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Отзывы
                </Link>
              </li>
              <li>
                <Link 
                  to="/team" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Наша команда
                </Link>
              </li>
              <li>
                <Link 
                  to="/partners" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Партнерские программы
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Услуги
                </Link>
              </li>
            </ul>
          </div>

          {/* Колонка 3 */}
          <div>
            <h3 className="font-mulish font-bold text-lg text-white mb-6">
              Блог
            </h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/news" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Новости
                </Link>
              </li>
              <li>
                <Link 
                  to="/blog/places" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Куда поехать?
                </Link>
              </li>
              <li>
                <Link 
                  to="/blog/tips" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Лайфхаки
                </Link>
              </li>
              <li>
                <Link 
                  to="/blog/reports" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Отчеты
                </Link>
              </li>
            </ul>
          </div>

          {/* Колонка 4 - Контакты */}
          <div>
            <h3 className="font-mulish font-bold text-lg text-white mb-6">
              Контакты
            </h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+74951043428" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                  +7 (495) 104-34-28
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@mirsg.ru" 
                  className="font-open-sans text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                  info@mirsg.ru
                </a>
              </li>
              <li>
                <address className="font-open-sans text-gray-300 not-italic flex items-start gap-2">
                  <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0"></i>
                  <span>Москва, ул. Тверская, 12, офис 34</span>
                </address>
              </li>
            </ul>

            {/* Социальные сети */}
            <div className="mt-6">
              <div className="flex items-center gap-4">
                <a 
                  href="https://vk.com/mirsg" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-[#1E88E5] rounded-full transition-colors duration-300 cursor-pointer"
                  aria-label="ВКонтакте"
                >
                  <i className="ri-vk-line text-white text-lg"></i>
                </a>
                <a 
                  href="https://t.me/mirsg" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-[#1E88E5] rounded-full transition-colors duration-300 cursor-pointer"
                  aria-label="Telegram"
                >
                  <i className="ri-telegram-line text-white text-lg"></i>
                </a>
                <a 
                  href="https://youtube.com/mirsg" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-[#1E88E5] rounded-full transition-colors duration-300 cursor-pointer"
                  aria-label="YouTube"
                >
                  <i className="ri-youtube-line text-white text-lg"></i>
                </a>
                <a 
                  href="https://dzen.ru/mirsg" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-[#1E88E5] rounded-full transition-colors duration-300 cursor-pointer"
                  aria-label="Дзен"
                >
                  <svg className="w-5 h-5 fill-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Нижняя строка */}
      <div className="border-t border-gray-800">
        <div className="max-w-[1360px] mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-open-sans text-gray-400 text-sm text-center md:text-left">
              © 2017 Турклуб «Мир своими глазами». Все права защищены
            </p>
            <div className="flex items-center gap-6">
              <Link 
                to="/privacy" 
                className="font-open-sans text-gray-400 hover:text-white text-sm transition-colors duration-300 cursor-pointer"
              >
                Политика конфиденциальности
              </Link>
              <Link 
                to="/terms" 
                className="font-open-sans text-gray-400 hover:text-white text-sm transition-colors duration-300 cursor-pointer"
              >
                Пользовательское соглашение
              </Link>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-open-sans text-gray-400 hover:text-white text-sm transition-colors duration-300 cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
